import { importBatchOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { toApiError } from "../../api/api-error";
import { sendJson, withQuery } from "../core/request";
import { progressKeys } from "../progress/keys";
import { workoutKeys } from "./keys";
/**
 * History in and out (`D201`): one import batch, and the CSV export.
 *
 * An import is not an outbox write. It is a deliberate, attended act on a
 * screen that shows its progress batch by batch, and a batch that fails is
 * shown and retried from there; the server answers a resend of a batch as
 * "already imported" (`created: false`), so retrying is always safe.
 */
/** `POST /me/imports` — one batch (`MAX_IMPORT_SESSIONS`, `MAX_IMPORT_SETS`). */
export function importHistoryBatch(api, input) {
    return sendJson(api, "POST", TRAINING_ROUTES.imports, input, importBatchOutput);
}
/** Every read an import can change: the history, its summaries and charts,
 *  the stats and every Progress aggregate. */
export function importHistoryMutation(api) {
    return {
        invalidates: [workoutKeys.all, progressKeys.all],
        mutationFn: (input) => importHistoryBatch(api, input),
        mutationKey: ["workout", "import"],
    };
}
/**
 * `GET /me/export.csv` — the whole file, as text. The SERVER streams it
 * (128 MB per isolate); the device holds it once, to hand it to the share
 * sheet or a download, which is a phone's memory and not an isolate's.
 */
export async function fetchExportCsv(api, query) {
    const response = await api.authorizedFetch(withQuery(TRAINING_ROUTES.exportCsv, { locale: query.locale }), { method: "GET" });
    if (!response.ok) {
        throw await toApiError(response);
    }
    return await response.text();
}
//# sourceMappingURL=history-transfer.js.map